<template>
  <div>
    <div class="enter_innovation_wrap">
      <div class="enter_img">
        <div class="img_tit hidden-xs-only">浙江清华长三角研究院</div>
        <div class="img_tit hidden-sm-and-up">浙江清华长三角研究院</div>
      </div>
    </div>
    <div class="warp">
      <div class="procard_wrap">
        <div class="procard_btn">
          <div
            class="procard_item"
            v-for="(item, index) in procardList"
            :key="index"
            :class="activeIndex === index ? 'active' : ''"
            @click="changeIndex(index)"
          >
            {{ item.tit }}
          </div>
        </div>
        <div class="procard_content" v-if="activeIndex === 0">
          <div class="content_left">
            <img src="@/assets/img/zuhe1.png" alt="" />
            <p class="item">
              习近平同志亲自谋划、直接推动、大力支持创建起来的新型创新载体
            </p>
            <p class="item">
              浙江省人民政府和清华大学共同组建的，实行自收自支、企业化管理的事业单位
            </p>
            <p class="item">
              浙江省实施“引进大院名校，共建创新载体”战略的先行者、引领者
            </p>
            <el-steps :active="6" class="steps">
              <el-step title="会商" description="2003年3月17日"></el-step>
              <el-step title="签约" description="2003年12月31日"></el-step>
              <el-step title="选址" description="2004年3月23日"></el-step>
              <el-step title="奠基" description="2005年4月10日"></el-step>
              <el-step title="视察" description="2008年10月29日"></el-step>
              <el-step title="批示" description="2014年5月11日"></el-step>
            </el-steps>
          </div>
          <div class="content_right">
            <div class="img">
              <img class="img1" src="@/assets/img/zuhe2.png" alt="" />
              <img class="img2" src="@/assets/img/zuhe3.png" alt="" />
            </div>
            <div class="item">七位一体”创新发展模式成为产学研合作样板</div>
          </div>
        </div>
        <div class="procard_content" v-else>
          <div class="content_left">
            <img class="img3" src="@/assets/img/zuhe4.png" alt="" />
          </div>
          <div class="content_right">
            <p class="item1">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浙江清华长三角研究院10年来的探索实践说明，
              省校合作是优化科技资源配置、 促进科技成果 转化、
              实现科技与经济融合的有效模式。希望 总结经验 ，再接再厉
              ，不断巩固省校合作成果， 全面深化科技体制改革 ，努力把长三角研究院
              建设成为具有先进水平的新型创新载体， 为推
              动区域创新体系建设作出更大的贡献
            </p>
            <p class="name">——习近平总书记在清华长三角研究院</p>
            <p class="time">10周年汇报上批示</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      disableTips: true,
      procardList: [
        {
          tit: "历程",
        },
        {
          tit: "指示",
        },
      ],
      wordCloud: null,
    };
  },
  mounted() {},
  methods: {
    changeIndex(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/rad.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
  }
}
.warp {
  width: 100%;
  display: flex;
  justify-content: center;
}
.procard_wrap {
  margin-top: 60px;
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;

  @media screen and (max-width: 768px) {
    margin-top: 40px;
    width: 95%;
    background: #f7f7f7;
  }
  .procard_btn {
    width: 100%;
    display: flex;
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        content: "▲";
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }
  .procard_content {
    width: 100%;
    display: flex;
    padding-top: 30px;
    justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .content_left {
      width: 50%;
      img {
        width: 100%;
      }
      .img3 {
        height: 300px;
        @media screen and (max-width: 768px) {
          height: 300px;
        }
      }
      .steps {
        margin-top: 20px;
      }
      .item {
        font-size: 16px;
        font-weight: 700;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          font-weight: 700;
        }
      }
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
    .content_right {
      width: 50%;
      height: 100%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-top: 20px;
      }
      .img {
        height: 80%;
        text-align: center;
        @media screen and (max-width: 768px) {
          height: 50%;
        }
        .img1,
        .img2 {
          height: 35%;
          @media screen and (max-width: 768px) {
            height: 45%;
          }
        }
      }
      .item {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          font-weight: 700;
        }
      }
      .item1 {
        font-size: 16px;
        font-weight: 700;
        @media screen and (max-width: 768px) {
          font-size: 12px;
          font-weight: 700;
        }
      }
      .name {
        text-align: right;
        @media screen and (max-width: 768px) {
          font-size: 10px;
        }
      }
      .time {
        text-align: right;
        font-size: 14px;
        @media screen and (max-width: 768px) {
          font-size: 10px;
        }
      }
    }
  }
}
</style>